module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../../../node_modules/happypack/loader.js?id=jsx!./BindWechatView.js"));
	}, "BindWechatView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=BindWechatView!./src/pages/Shop/Member/Personal/Account/BindWechat/BindWechatView.js
// module id = 1904
// module chunks = 367